import { tooltipClasses } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Project } from '~hooks/useProjects/models';

import { Label, Value } from '../../styled';

interface InternalNotesProps {
  project: Project;
}

export default function InternalNotes({ project }: InternalNotesProps) {
  const internalNotes = project.internalNotes;

  if (!internalNotes) {
    return null;
  }

  const labelledNotes = `${t('form_fields.internal_notes')}: ${internalNotes}`;

  return (
    <Tooltip
      placement="bottom-start"
      slotProps={{
        tooltip: { sx: { [`&.${tooltipClasses.tooltip}`]: { whiteSpace: 'pre-line' } } },
      }}
      title={labelledNotes}
    >
      <OverflowAwareText
        sx={(theme) => ({
          // Muted secondary ink keeps the note visible but not overly emphasized,
          // and resolves to a legible color in both light and dark mode.
          color: theme.semantic.textSecondary,
          fontSize: '12px',
        })}
      >
        {/* Label hardcodes a fixed brand ink color, so override it to inherit and
            keep the whole line reading as one muted tone. */}
        <Label sx={{ color: 'inherit' }}>{t('form_fields.internal_notes')}: </Label>
        <Value>{internalNotes}</Value>
      </OverflowAwareText>
    </Tooltip>
  );
}
